var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 9.25H7.29167H30.625",
    stroke: "#FF0000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6665 9.25008V6.33341C11.6665 5.55987 11.9738 4.818 12.5208 4.27102C13.0678 3.72404 13.8096 3.41675 14.5832 3.41675H20.4165C21.1901 3.41675 21.9319 3.72404 22.4789 4.27102C23.0259 4.818 23.3332 5.55987 23.3332 6.33341V9.25008M27.7082 9.25008V29.6667C27.7082 30.4403 27.4009 31.1822 26.8539 31.7291C26.3069 32.2761 25.5651 32.5834 24.7915 32.5834H10.2082C9.43462 32.5834 8.69276 32.2761 8.14578 31.7291C7.59879 31.1822 7.2915 30.4403 7.2915 29.6667V9.25008H27.7082Z",
    stroke: "#FF0000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4165 16.5417V25.2917",
    stroke: "#FF0000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5835 16.5417V25.2917",
    stroke: "#FF0000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.2503fb5301eb23966eef7ac3d1d9a845.svg";
export { ForwardRef as ReactComponent };